export default __webpack_public_path__ + "static/media/sipmenu-bank.bc3939cc.svg";